import { z } from "zod"

export const GoogleCloudServiceAccountKeySchema = z.object({
    type: z.literal("service_account"),
    project_id: z.string(),
    private_key_id: z.string(),
    private_key: z.string(),
    client_email: z.string(),
    client_id: z.string(),
    auth_uri: z.string(),
    token_uri: z.string(),
    auth_provider_x509_cert_url: z.string(),
    client_x509_cert_url: z.string(),
    universe_domain: z.string(),
})

export type GoogleCloudServiceAccountKey = z.infer<typeof GoogleCloudServiceAccountKeySchema>
